import { useCallback, useEffect } from 'react';

// https://usehooks.com/useKeyPress/
// Hook
export function useKeyPress(
  targetKey: string,
  {
    keydownCallback,
    keyupCallback,
  }: { keydownCallback?: () => void; keyupCallback?: () => void }
): void {
  // If pressed key is our target key then set to true
  const downHandler = useCallback(
    ({ key }): void => {
      if (key === targetKey) {
        keydownCallback && keydownCallback();
      }
    },
    [keydownCallback, targetKey]
  );
  // If released key is our target key then set to false
  const upHandler = useCallback(
    ({ key }): void => {
      if (key === targetKey) {
        keyupCallback && keyupCallback();
      }
    },
    [keyupCallback, targetKey]
  );
  // Add event listeners
  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [downHandler, upHandler]); // Empty array ensures that effect is only run on mount and unmount
}
